/* eslint-disable max-len */
import React from 'react';

export function RightChevron() {
  return (
    <svg viewBox='0 0 24 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='Type=Divider'>
        <path
          id='icon/hardware/keyboard_arrow_right_24px'
          d='M10 12.8751L13.88 8.9951L10 5.1151C9.81275 4.92827 9.70752 4.67462 9.70752 4.4101C9.70752 4.14558 9.81275 3.89193 10 3.7051C10.39 3.3151 11.02 3.3151 11.41 3.7051L16 8.2951C16.39 8.6851 16.39 9.3151 16 9.7051L11.41 14.2951C11.02 14.6851 10.39 14.6851 10 14.2951C9.62001 13.9051 9.61001 13.2651 10 12.8751Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
